import { ACCESS_ROLES } from '../functional/roles';

export const roleChecker = {
  isAdministrative: (role) => role === +ACCESS_ROLES.ROOT || role === +ACCESS_ROLES.ADMIN || role === +ACCESS_ROLES.CLINIC,
  isDoctor: (role) => role === +ACCESS_ROLES.DOCTOR,
  isRoot: (role) => role === +ACCESS_ROLES.ROOT,
  isUser: (role) => role === +ACCESS_ROLES.USER,
};
